const sliders = Array.from(document.querySelectorAll('.yc-image-slider'));

sliders.forEach(container => {
  const sliderTarget = container.querySelector('.yc-image-slider-main__target');
  const sliderMain = container.querySelector('.yc-image-slider-main__target img');
  const sliderMainText = container.querySelector('.yc-image-slider-main__text');

  const sliderThumbnails = Array.from(
    container.querySelectorAll('.yc-image-slider-thumbnail__item img')
  );
  const sliderParagraphs = Array.from(
    container.querySelectorAll('.yc-image-slider-thumbnail__item p')
  );

  if (!sliderMain || !sliderThumbnails.length || !sliderMainText) return;

  let currentIndex = 0;
  let isAnimating = false;

  /* =========================
     矢印生成
  ========================= */
  const btnPrev = document.createElement('button');
  btnPrev.className = 'slider-prev';

  const btnNext = document.createElement('button');
  btnNext.className = 'slider-next';

  sliderMain.parentElement.appendChild(btnPrev);
  sliderMain.parentElement.appendChild(btnNext);

  /* =========================
     ドット生成
  ========================= */
  const dotsWrapper = document.createElement('div');
  dotsWrapper.className = 'slider-dots';
  sliderTarget.parentElement.appendChild(dotsWrapper);

  const dots = sliderThumbnails.map((_, i) => {
    const dot = document.createElement('button');
    if (i === 0) dot.classList.add('active');
    dot.addEventListener('click', () => updateMain(index = i));
    dotsWrapper.appendChild(dot);
    return dot;
  });

  /* =========================
     srcset 最大サイズ取得
  ========================= */
  const getLargestSrc = (img) => {
    if (!img.srcset) return img.src;
    const candidates = img.srcset
      .split(',')
      .map(s => s.trim().split(' ')[0]);
    return candidates[candidates.length - 1];
  };

  /* =========================
     メイン更新（画像＋テキスト）
  ========================= */
  const updateMain = (index) => {
    if (isAnimating) return;
    isAnimating = true;

    const thumb = sliderThumbnails[index];
    const text = sliderParagraphs[index]?.innerHTML || '';

    // フェードアウト
    sliderMain.style.transition = 'opacity 0.4s';
    sliderMainText.style.transition = 'opacity 0.4s';
    sliderMain.style.opacity = 0;
    sliderMainText.style.opacity = 0;

    setTimeout(() => {
      // 画像更新
      sliderMain.src = getLargestSrc(thumb);
      sliderMain.srcset = thumb.srcset || '';
      sliderMain.sizes = thumb.sizes || '';

      // テキスト更新
      sliderMainText.innerHTML = text;

      // active更新（サムネ）
      sliderThumbnails.forEach(t => t.classList.remove('active'));
      thumb.classList.add('active');

      // active更新（ドット）
      dots.forEach(d => d.classList.remove('active'));
      dots[index].classList.add('active');

      // フェードイン
      sliderMain.style.opacity = 1;
      sliderMainText.style.opacity = 1;

      setTimeout(() => {
        isAnimating = false;
      }, 400);
    }, 200);

    currentIndex = index;
  };

  /* =========================
     初期表示
  ========================= */
  updateMain(0);

  /* =========================
     サムネクリック
  ========================= */
  sliderThumbnails.forEach((thumb, i) => {
    thumb.addEventListener('click', () => updateMain(i));
  });

  /* =========================
     矢印クリック
  ========================= */
  btnPrev.addEventListener('click', () => {
    let newIndex = currentIndex - 1;
    if (newIndex < 0) newIndex = sliderThumbnails.length - 1;
    updateMain(newIndex);
  });

  btnNext.addEventListener('click', () => {
    let newIndex = currentIndex + 1;
    if (newIndex >= sliderThumbnails.length) newIndex = 0;
    updateMain(newIndex);
  });
});